<template>
  <div class='xy-content-visitInvitation'>
    <div class='xy-content-title-visitInvitation'  v-show="!isShowThemeSearch">
      <div v-if="!defaultDate">
          <img style="margin-right: 5px;width:8%;height:atou" :src="require('@/assets/schoolAffairs/shaixuanxuanzhong.svg')" />
          <span @click="isShowPreDate=true">时间筛选</span>
      </div>
      <div v-else  @click="isShowPreDate=true">{{defaultDate}}</div>
      <div @click="themeSearch">
          <!-- <img style="margin-right: 5px;" :src="require('@/assets/schoolAffairs/shaixuanxuanzhong.svg')" /> -->
          <van-icon name="search" size="20" style="margin-right:2px" />
          <span style="vertical-align: super;">搜索</span>
      </div>
    </div>
    <div class="theme-search" v-show="isShowThemeSearch">
      <van-search
        ref="inputsearch"
        v-model="svalue"
        show-action
        placeholder="请输入邀约人姓名或主题"
        @search="onSearch"
        @cancel="onCancel"
        autofocus="autofocus"
      />
    </div>
    <div class='xy-content-body-visitInvitation'>
        <div >
            <van-pull-refresh v-model="isLoading" class="visitlists-refresh" @refresh="onRefresh">
                <van-list
                class="refreshWrap"
                v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                >
                <ul class="visit-list" v-if="list.length>0">
                    <li class="leave-item clearfix" v-for="(item,index) in list" :key="index" >
                      <div @click="details(item)">
                        <div class="right">
                            <div class="content" >
                              <div>
                                <img :src="approvalImg[index]" />
                              </div>
                              <span style="word-break: break-all;word-wrap: break-word;">{{item ? item.InvatationTitle:''}}</span>
                            </div>
                            <div class="title">
                                <div class="nowrap tit">入校时间：{{item ? item.InvatationArriveTime : ''}}</div>
                                <div class="date fr">查看详情 ></div>
                            </div>
                        </div>
                      </div>
                    </li>
                </ul>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
    <!-- 日期 -->
    <van-popup v-model="isShowPreDate" position="bottom" :style="{ height: '45%' }">
      <van-datetime-picker
        v-model="currentDate"
        @confirm="preDateConfirm"
        @cancel="preDateCancle"
        type="date"
      ></van-datetime-picker>
    </van-popup>
  </div>
</template>
<script>
  export default {
    name: '',
    data () {
      return {
        list:[],
        isShowSearchBar: false, //搜索框展示
        showSelectCon: false, //筛选下拉框展示
        pageIndex: 1,
        PageSize: 15,
        total: 0, //总共的数据条数
        isLoading: false, //下拉刷新状态
        isRefresh: false, // 是否加载中
        finished: false, // 加载是否完成
        svalue: '',
        isShowThemeSearch:false,
        isShowPreDate: false,
        currentDate: new Date(),
        defaultDate:'',
        approvalImg : []
      }
    },
    created () {},
    mounted () {},
    methods :{
      //获取接口数据 StudentLeaveSubApplication
      async onLoad(){
          await this.getList();
          // 加载状态结束
          this.isRefresh = false;
          this.pageIndex++;   
      },
      //下拉加载
      onRefresh() {
          this.pageIndex = 1;
          this.isLoading = false;
          this.list = []
          if(this.finished){
          this.finished = false;
          }else{
          this.onLoad()
          }
      },
      async getList() {
           console.log(this.finished)
        this.xy.loading();
        let params = {
          pageIndex:  this.pageIndex,
          pageSize: this.PageSize,
          invatationTitle: this.searchTheme, // 邀请主题
          invatationArriveTime: this.defaultDate ? this.defaultDate : '', // 邀请到访时间
          invatationUser: '' // 受邀人
        }
        let res = await this.xyapi.get(
          this.xyMApi+'/vst' + "/invatation/GetInvatationPagelist",params
         // 'http://devpczx.xiaoyangedu.net:9092' + '/vst/invatation/GetInvatationPagelist', params
        )
        this.xy.unloading();
        if (res !== undefined && res.success) {
          // this.xy.unloading();
          // 将新数据与老数据进行合并
          if (res.data === null) {
            this.finished = true;
            return;
          }
          console.log(res.data.data)
          this.list = this.list.concat(res.data.data?res.data.data:[]);
          for(var i=0;i<this.list.length;i++){
            this.approvalImg.push(require("@/assets/schoolAffairs/zi.png"),require("@/assets/schoolAffairs/fen.png"),require("@/assets/schoolAffairs/lan.png"),require("@/assets/schoolAffairs/lu.png"))
          }
          console.log(this.list)
          this.total = res.data.totalRecords; //后端传的总条数
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (this.list === null || this.list.length === 0 || this.list.length >= this.total)
          {
            this.finished = true;
            this.xy.unloading();
            return;
          }
              console.log(this.finished)
        }else{
            this.xy.msgError(res.msg)
            this.finished = true;
            }
     },
      //详情
      details(val){
        console.log(val.InvatationInfoID)
        this.$router.push({
          path: "/home/LaunchInvitationDetails",
          query: {
            invatationInfoID: val.InvatationInfoID,
            isFrom: "invitationList"
          }
        });
      },
      onSearch(val) {
        console.log(val)
        this.searchTheme = val
        this.pageIndex = 1;
        this.list = []
        if(this.finished){
          this.finished = false;
        }else{
          this.onLoad();
        }
        },
      onCancel() {
        this.isShowThemeSearch = false
      },
      //显示隐藏搜索框
      themeSearch(){
        this.isShowThemeSearch = true
        this.svalue = this.searchTheme
        var isearch = document.getElementsByClassName("van-field__control")[0]
        this.$nextTick( () =>{
            isearch.focus()
        })
      },
      //到访日期
      preDateConfirm(val) {
        this.defaultDate = this.xy.moment(val).format("YYYY-MM-DD");
        console.log(this.defaultDate)
        this.pageIndex = 1;
        this.list = []
        this.isShowPreDate = false;
        if(this.finished){
          this.finished = false;
        }else{
          this.onLoad();
        }
      },
      preDateCancle() {
        this.defaultDate = ''
        this.pageIndex = 1;
        this.list = []
        this.isShowPreDate = false;
        if(this.finished){
          this.finished = false;
        }else{
          this.onLoad();
        }
      }
    }
  }
</script>
<style lang='less' scoped>
  .xy-content-title-visitInvitation{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 82px;
    background: #ffffff;
    div{
      flex: 1;
      text-align: center;
    }
  }
  .theme-search{
    width: 100%;
    height: 82px;
  }
  .visitlists-refresh {
    .refreshWrap {
         padding-bottom: 140px;
      .visit-list {
        padding: 15px;
        .leave-item {
          background: #fff;
          border-radius: 14px;
          // box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
          margin-bottom: 16px;
          .right {
            // padding-left: 30px;

            .title {
              display: flex;
              justify-content: space-between;
              padding: 6px 31px 14px 19px;
              .tit {
                flex: 1;
                max-width: 60%;
                font-size: 26px;
                line-height: 64px;
                color: #999999;
              }

              .date {
                line-height: 64px;
                color: #1677FF;
             
              }
            }
            .content {
              padding: 46px 31px 56px 19px;
              border-bottom: 1px #eee solid;
              color: #666;
              margin-top: 10px;
              display: flex;
              align-items: center;
              div{
                width: 70px;
                height: 70px;
                background: #F2EEFF;
                text-align: center;
                line-height: 70px;
                border-radius: 8px;
                img{
                  width: 50%;
                  height: 50%;
               }
              }
              span{
                flex: 6;
                margin-left: 30px;
                font-weight: 600;
              }
            }
            .status {
              font-size: 28px;
              margin: 17px 0 0;
              color: #666;
            }
          }
        }
      }
    }
  }
  .theme-search /deep/ .van-search__content{
      border-radius: 30px;
      border:1px solid #cccccc;
      background: #ffffff;
  }
  .theme-search /deep/ .van-search__action{
    color: #1677FF;
  }
</style>
